import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";
import ReportDaily_Settings from "./settings";

export default class ReportDaily extends Report<ReportDaily_Settings> {

    static reportName   : string = "Attendance daily report"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_DAILY
        super(data);

        this.icon           = "isvg-time-entries"
        this.name           = data.name || "Attendance daily report"
        this.description    = "Displays all clock-in and clock-out times for each user, organized by day."

        this.settings       = new ReportDaily_Settings(data.settings)
    }

    static initFromSavedView(savedView:SavedView): ReportDaily {
        return new ReportDaily(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportDaily_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }
}
